import React from "react";
import team1 from "./team1.png";
import team2 from "./team3.png";
import team3 from "./team2.png";
import team4 from "./team4.png";
import "./team.css";

const Team = () => {
  return (
    <>
   
    <div className="main-wrapper">
    <div className="wrapper">
      <h1>Our Team</h1>
      <div className="team">
        <div className="team_member">
          <div className="team_img">
            <img src={team1} alt="Team_image" />
          </div>
          <h3>Joseph Thogo</h3>
          <p className="role">CEO Sungura</p>
          <p>
          Hi there! I'm Joseph Thogo, the CEO of Sungura. Apart from steering Sungura towards success, I'm also deeply passionate about software development and 2D animation. With years of experience in these fields.
          </p>
        </div>
        <div className="team_member">
          <div className="team_img">
            <img src={team4} alt="Team_image" />
          </div>
          <h3>Ivy Wamalwa</h3>
          <p className="role">Motion Graphics Designer</p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Est quaerat
            tempora, voluptatum quas facere dolorum aut cumque nihil nulla harum
            nemo distinctio quam blanditiis dignissimos.
          </p>
        </div>
        <div className="team_member">
          <div className="team_img">
            <img src={team3} alt="Team_image" />
          </div>
          <h3>Mary Karuki</h3>
          <p className="role">Web & App developer</p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Est quaerat
            tempora, voluptatum quas facere dolorum aut cumque nihil nulla harum
            nemo distinctio quam blanditiis dignissimos.
          </p>
        </div>
        <div className="team_member">
          <div className="team_img">
            <img src={team2} alt="Team_image" />
          </div>
          <h3>Anthony Maingi</h3>
          <p className="role">DATA ANALYST & SEO PRO</p>
          <p>
          Hi there! I'm Anthony maingi, a data analyst and SEO with blend of Graphic Design and social Media management.  I'm also deeply passionate about Marketing and Communications. With years of experience in these fields.
          </p>
        </div>
      </div>
    </div>
    </div>
    {/* <div style={{height: '100vh'}}></div> */}
    </>
  );
};

export default Team;
